export const protocol = process.env.REACT_APP_ENV_NAME === 'local' ? '' : 'https://';
